/* istanbul ignore file */
import { useModalStore } from '~/stores/useModalStore';
import { useModalOverlayStore } from '@nuxt-common/atomic-ui/app/stores/useModalOverlayStore';

export function useModal() {
  const store = useModalStore();
  const atomicUiStore = useModalOverlayStore();
  const { modal } = storeToRefs(store);

  return {
    registerModal: (payload) => store.setModal(payload),
    toggleModal: (id) => atomicUiStore.setModalOverlayVisibility(id),
    modal,
  };
}
